<!--*****************************************************************
  * Copyright (c) Certus Software, 2021.                            *
  *                                                                 *
  * This unpublished material is proprietary to Certus Software.    *
  * All rights reserved. The methods and techniques described       *
  * herein are considered confidential and/or trade secrets.        *
  * Reproduction or distribution, in whole or in part, is forbidden *
  * except by express written permission of Certus Software.        *
  *****************************************************************-->
<header>
  <mat-toolbar>
    <nav [attr.aria-label]="'app.skipToContent' | translate">
      <a class="pushable-icon orange-push visible-hidden" href="{{this.router.url.split('#')[0]}}#mainContent">
        <span class="front">
          <span>{{'app.skipToContent' | translate}}</span>
        </span>
      </a>
    </nav>
    <a class="app-logo" [routerLink]="'/'">
      <img src="./assets/img/veglegestorles-logo.svg" alt="Véglegestörlés.hu">
    </a>
    <span class="fill-empty-space"></span>
    <nav>
      <div class="header-menu">
        <div class="guide-btn">
          <a #guideButton [routerLink]="'/guide'" class="nav-btn" style="z-index:1050" routerLinkActive="active"
             [attr.aria-current]="(router?.url === '/guide')?'page':((this.router.url.includes('/guide'))?'location':null)"
             [ariaCurrentWhenActive]="(router?.url === '/guide')?'page':((this.router.url.includes('/guide'))?'location':null)">
            <span class="nav-front">
              {{'app.titles.guide' | translate}}
            </span>
          </a>
          <button mat-icon-button [matMenuTriggerFor]="guideMenu" [attr.aria-label]="('app.openGuideMenu' | translate)">
            <mat-icon>expand_more</mat-icon>
          </button>
        </div>
        <mat-menu #guideMenu="matMenu" class="guide-menu" yPosition="above" xPosition="before">
          <span class="menu-hv">
            <div class="pc-guide">
              <p class="s-h5">
                <a class="hover-underline-animation" [routerLink]="'/guide/pc'" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                  {{'app.titles.guideItems.pcLabel' | translate}}
                </a>
              </p>
              <a mat-menu-item [routerLink]="'/guide/pc/windows'" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                <img src="assets/img/icons/windows.svg" aria-hidden="true" alt="" width="24px">
                <span class="small">{{'app.titles.guideItems.windows' | translate}}</span>
              </a>
              <a mat-menu-item [routerLink]="'/guide/pc/macos'" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                <img src="assets/img/icons/apple.svg" aria-hidden="true" alt="" height="24px">
                <span class="small">{{'app.titles.guideItems.apple' | translate}}</span>
              </a>
              <a mat-menu-item [routerLink]="'/guide/pc/linux'" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                <img src="assets/img/icons/linux.svg" aria-hidden="true" alt="" height="24px">
                <span class="small">{{'app.titles.guideItems.linux' | translate}}</span>
              </a>
            </div>
            <div class="mobile-guide">
              <p class="s-h5">
                <a class="hover-underline-animation" [routerLink]="'/guide/mobile'" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                  {{'app.titles.guideItems.mobileLabel' | translate}}
                </a>
              </p>
              <a mat-menu-item [routerLink]="'/guide/mobile/android'" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                <img src="assets/img/icons/android.svg" aria-hidden="true" alt="" width="24px">
                <span class="small">{{'app.titles.guideItems.android' | translate}}</span>
              </a>
              <a mat-menu-item [routerLink]="'/guide/mobile/ios'" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                <img src="assets/img/icons/ios.svg" aria-hidden="true" alt="" width="20px">
                <span class="small">{{'app.titles.guideItems.macos' | translate}}</span>
              </a>
            </div>
          </span>
        </mat-menu>
        <a class="nav-btn" [routerLink]="'/devices/supported'" routerLinkActive="active" ariaCurrentWhenActive="page">
          <span class="nav-front">
            {{'app.titles.supportedDevices' | translate}}
          </span>
        </a>
      </div>
      <div class="header-actions">
        <a *ngIf="!(isLoggedIn | async)" class="pushable green-push" [routerLink]="'/register'" routerLinkActive="active" ariaCurrentWhenActive="page">
          <span class="front">
            {{'app.titles.licenseActivation' | translate}}
          </span>
        </a>
        <a *ngIf="!(isLoggedIn | async)" class="icon-button login-btn" [routerLink]="'/login'" routerLinkActive="active" ariaCurrentWhenActive="page">
          <span></span>
          <span class="visible-hidden">{{'app.titles.login' | translate}}</span>
        </a>
        <div *ngIf="(isLoggedIn | async)" class="account-btn">
          <a class="pushable green-push push-icon-btn" [routerLink]="'/'" routerLinkActive="active" ariaCurrentWhenActive="page">
            <span class="front">
              <i class="user-icon"></i>
              <span>{{'app.titles.myAccount' | translate}}</span>
            </span>
          </a>
          <div *ngIf="user.userType === UserType.Registered">
            <button mat-icon-button [matMenuTriggerFor]="accountMenu" [attr.aria-label]="('app.openAccountMenu' | translate)">
              <mat-icon>expand_more</mat-icon>
            </button>
            <mat-menu #accountMenu="matMenu" class="account-menu" yPosition="above" xPosition="before">
              <span class="menu-hv">
                <a class="hover-underline-animation small" mat-menu-item [routerLink]="'/app/change-password'" routerLinkActive="active-m" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                  {{'resetPassword.change.form.changePassword' | translate}}
                </a>
              </span>
            </mat-menu>
          </div>
        </div>
        <button *ngIf="(isLoggedIn | async)" class="icon-button logout-btn" (click)="logout()">
          <span></span>
          <span class="visible-hidden">{{'app.titles.logout' | translate}}</span>
        </button>
        <button class="language-btn" (click)="changeAppLanguage()" [attr.aria-label]="('app.languageBtnAria' | translate)">
          <span>{{'app.languageBtnText' | translate}}</span>
        </button>
      </div>
      <button (click)="appDrawer.toggle()" class="toggle-menu-btn">
        <span></span>
        <span class="visible-hidden">{{'app.menuLabel' | translate}}</span>
      </button>
    </nav>
  </mat-toolbar>
</header>
